import React from 'react';
import { ControlMode } from 'core/models/drive';
import { DriveModeButton } from '../../atoms/DriveModeButton';
import { exhaustiveCheck } from 'utility/exhaustiveCheck';
import styled from '@emotion/styled';

const RemoteButton = DriveModeButton;

const AutoButton = styled(DriveModeButton)({
    backgroundColor: '#5cb85c', borderColor: '#4cae4c',
    hover: { backgroundColor: '#449d44', borderColor: '#398439' }
});

function textForMode(mode: ControlMode) {
    switch (mode) {
        case ControlMode.Remote:
            return 'REMOTE';
        case ControlMode.Auto:
            return 'AUTO';
        default:
            throw (exhaustiveCheck(mode));
    }
}

export type ControlModeButtonProps = {
    className?: string;
    mode: ControlMode;
    disabled?: boolean;
    onClick?: () => void;
}

export const ControlModeButton = (props: ControlModeButtonProps) => {
    const text = textForMode(props.mode);

    return (
        text === 'REMOTE'
            ? <RemoteButton {...props}>{text}</RemoteButton>
            : <AutoButton {...props} >{text}</AutoButton>
    );
};
